import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeGuard } from './shared/guards/home.guard';
import { LoginGuard } from './shared/guards/login.guard';
import { StyleguideGuard } from './shared/guards/styleguide.guard';
import { APP_ROUTES } from './shared/constants/app-routes.constant';
import { ConsultaCoberturaGuard } from './shared/guards/consulta-cobertura.guard';

const ROUTES: Routes = [
  {
    path: APP_ROUTES.home.route,
    loadChildren: () => import('./pages/home/home.module').then((m) => m.HomeModule),
    canLoad: [HomeGuard],
    canActivate: [HomeGuard]
  },
  {
    path: APP_ROUTES.services.route,
    loadChildren: () => import('./pages/servicos/servicos.module').then((m) => m.ServicosModule)
  },
  {
    path: APP_ROUTES.helpCenter.route,
    loadChildren: () => import('./pages/central-de-ajuda/central-de-ajuda.module').then((m) => m.CentralDeAjudaModule)
  },
  {
    path: APP_ROUTES.consultaCobertura.route,
    loadChildren: () =>
      import('./pages/consulta-cobertura/consulta-cobertura.module').then((m) => m.ConsultaCoberturaModule),
    canLoad: [ConsultaCoberturaGuard],
    canActivate: [ConsultaCoberturaGuard]
  },
  {
    path: APP_ROUTES.hospitalMedicalGuide.route,
    loadChildren: () =>
      import('./pages/guia-medico-hospitalar/guia-medico-hospitalar.module').then((m) => m.GuiaMedicoHospitalarModule)
  },
  {
    path: APP_ROUTES.myAccount.route,
    loadChildren: () => import('./pages/minha-conta/minha-conta.module').then((m) => m.MinhaContaModule),
    canLoad: [LoginGuard]
  },
  {
    path: APP_ROUTES.profile.route,
    loadChildren: () => import('./pages/perfil/perfil.module').then((m) => m.PerfilModule),
    canLoad: [LoginGuard]
  },
  {
    path: APP_ROUTES.attendanceHistory.route,
    loadChildren: () =>
      import('./pages/historico-de-atendimentos/historico-de-atendimentos.module').then(
        (m) => m.HistoricoDeAtendimentosModule
      ),
    canLoad: [LoginGuard]
  },
  {
    path: APP_ROUTES.satisfactionSurvey.route,
    loadChildren: () =>
      import('./pages/pesquisa-de-satisfacao/pesquisa-de-satisfacao.module').then((m) => m.PesquisaDeSatisfacaoModule),
    canLoad: [LoginGuard],
    pathMatch: 'full'
  },
  {
    path: APP_ROUTES.satisfactionSurveyHash.route,
    loadChildren: () =>
      import('./pages/pesquisa-de-satisfacao/pesquisa-de-satisfacao.module').then((m) => m.PesquisaDeSatisfacaoModule),
    pathMatch: 'full'
  },
  {
    path: APP_ROUTES.styleguide.route,
    loadChildren: () => import('./pages/styleguide/styleguide.module').then((m) => m.StyleguideModule),
    canLoad: [StyleguideGuard]
  },

  {
    path: APP_ROUTES.pesquisaPrestadores.route,
    loadChildren: () =>
      import('./pages/pesquisa-prestadores/pesquisa-prestadores.module').then((m) => m.PesquisaPrestadoresModule)
  },

  {
    path: APP_ROUTES.simulador.route,
    loadChildren: () => import('./pages/simulador/simulador.module').then((m) => m.SimuladorModule)
  },

  {
    path: '',
    redirectTo: APP_ROUTES.home.route,
    pathMatch: 'full'
  },
  {
    path: '**',
    redirectTo: APP_ROUTES.home.route
  }
];

@NgModule({
  imports: [RouterModule.forRoot(ROUTES, { scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
